const calculator = {
  houseGroupElements: {
    i_walls: {
      labels: ["x", "y", "n"],
    },
    i_gables: {
      labels: ["x", "&ang;", "n"],
    },
    i_triangles: {
      labels: ["x", "&ang;", "n"],
    },
    i_details: {
      labels: ["x", "y", "n"],
    },
    i_bows: {
      labels: ["x", "y", "n"],
    },
    i_columns: {
      labels: ["x", "y", "n"],
    },
    i_doors: {
      labels: ["x", "y", "n"],
    },
    i_windows: {
      labels: ["x", "y", "n"],
    },
    i_openings: {
      labels: ["x", "y", "n"],
    },
  },

  init: function () {
    calculator.events();
  },

  events: function () {
    $("body").on("click", ".choose-element", function (e) {
      e.preventDefault();
    });

    $("body").on("keydown", 'input[type="text"]', function (e) {
      var self = $(this),
        form = self.parents("form:eq(0)"),
        focusable,
        next;
      if (e.keyCode == 13) {
        focusable = form
          .find('input[type="text"]')
          .filter(":not([readonly]):enabled");
        next = focusable.eq(focusable.index(this) + 1);
        if (next.length) {
          next.select();
          next.focus();
        } else {
          $(this).trigger("change");
          e.preventDefault();
        }
        return false;
      }
    });
    var purlins = new WallSet();
    var beams = new WallSet();

    // Adds new letter group
    $("body").on("click", ".letters .new-value", function (e) {
      e.preventDefault();
      var btn = $(this);
      $.each(calcData.letters, function (letter, visible) {
        if (!visible) {
          calcData.letters[letter] = true;

          // Registers wall
          newWall = new WallSet();
          newWall.name = letter;

          // Adds set data el
          var setDataHtml =
            '<div class="add-value" data-val="' +
            letter +
            '" data-type="letter">' +
            "<label>" +
            letter +
            '</label><input type="text" value="0.00" class="test" readonly />' +
            '<a class="delete-value" href="#"></a>' +
            "</div>";

          btn.parent().before(setDataHtml);

          // Adds wall set gen el
          var wallSetGenHtml =
            '<div class="wall-set" data-wall-letter="' +
            letter +
            '">' +
            '<p class="wall-set__choosen">' +
            i18n.wall_set +
            ": <span>" +
            letter +
            "</p>" +
            '<p class="wall-set__choosen--small">0.00 m<sup>2</sup></p>' +
            '<div class="walls">' +
            "<p>" +
            i18n.wall +
            ': <span class="wall">0.00</span></p>' +
            "<p>" +
            i18n.gable +
            ': <span class="gable">0.00</span></p>' +
            "<p>" +
            i18n.triangle +
            ': <span class="triangle">0.00</span></p>' +
            "<p>" +
            i18n.detail +
            ': <span class="detail">0.00</span></p>' +
            "<p>" +
            i18n.bow +
            ': <span class="bow">0.00</span></p>' +
            "<p>" +
            i18n.column +
            ': <span class="column">0.00</span></p>' +
            "<p>" +
            i18n.door +
            ': <span class="door">0.00</span></p>' +
            "<p>" +
            i18n.window +
            ': <span class="window">0.00</span></p>' +
            "<p>" +
            i18n.opening +
            ': <span class="opening">0.00</span></p>' +
            "</div>" +
            "</div>";

          $(".wall-set-letter-generator").append(wallSetGenHtml);

          // Adds wall set conf el
          var groupHtml = "";
          $.each(calculator.houseGroupElements, function (index, data) {
            groupHtml +=
              '<div class="calc-size ' +
              index +
              '">' +
              '<form class="calc-size__inner flexbox flexbox--grid flexbox--small">' +
              '<div class="col col-50 col-s-full">' +
              '<div class="form-group">' +
              '<a class="delete-value" href="#"></a>' +
              '<div class="form-group__row">' +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[0] +
              "</label>" +
              '<input class="x" type="text" value="0">' +
              "</div>" +
              "</div>" +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[1] +
              "</label>" +
              '<input class="y" type="text" value="0">' +
              "</div>" +
              "</div>" +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[2] +
              "</label>" +
              '<input class="n" type="text" value="1">' +
              "</div>" +
              "</div>" +
              "</div>" +
              '<div class="size-summ">' +
              i18n.label_sum +
              ": <span>0.00</span> m<sup>2</sup></div>" +
              "</div>" +
              "</div>" +
              '<div class="col col-50 col-s-full">' +
              '<button class="btn form-group new-size" type="submit">' +
              i18n.label_add +
              "</button>" +
              "</div>" +
              "</form>" +
              "</div>";
          });
          var wallSetConfHtml =
            '<div class="choosen-elements hidden" data-for-configuration="' +
            letter +
            '">' +
            '<div class="image img-bg i_walls"></div>' +
            '<div class="btn-group img-group">' +
            '<a class="btn choose-element active" data-name="i_walls" href="#">' +
            i18n.wall +
            "</a>" +
            '<a class="btn choose-element" data-name="i_gables" href="#">' +
            i18n.gable +
            "</a>" +
            '<a class="btn choose-element" data-name="i_triangles" href="#">' +
            i18n.triangle +
            "</a>" +
            '<a class="btn choose-element" data-name="i_details" href="#">' +
            i18n.detail +
            "</a>" +
            '<a class="btn choose-element" data-name="i_bows" href="#">' +
            i18n.bow +
            "</a>" +
            '<a class="btn choose-element" data-name="i_columns" href="#">' +
            i18n.column +
            "</a>" +
            '<a class="btn choose-element" data-name="i_doors" href="#">' +
            i18n.door +
            "</a>" +
            '<a class="btn choose-element" data-name="i_windows" href="#">' +
            i18n.window +
            "</a>" +
            '<a class="btn choose-element" data-name="i_openings" href="#">' +
            i18n.opening +
            "</a>" +
            "</div>" +
            '<div class="letter-' +
            letter +
            '">' +
            groupHtml +
            "</div>" +
            "</div>";

          $(".wall-set-letter-configuration").append(wallSetConfHtml);

          walls_letters[letter] = newWall;

          return false;
        }
      });
    });

    // Deletes letter group
    $("body").on("click", ".letters .add-value .delete-value", function () {
      var val = $(this).parent(".add-value").data("val");

      calcData.letters[val] = false;

      $('[data-wall-letter="' + val + '"]').remove();
      $('[data-for-configuration="' + val + '"]').remove();

      delete walls_letters[val];

      $(this).parents(".add-value").remove();

      delete calcData.objects[val];

      var sum_of_total = $(".SumOfTotal").val();

      sum_of_total -= parseFloat(
        $(this).parents(".add-value").find('input[type="text"]:first').val()
      );

      $.ajax({
        url:
          "/" +
          $(".caluclator-wrap").data("lang") +
          "/generate-pdf/?delete_symbol=" +
          val +
          "&_wpnonce=" +
          $("#calculator-nonce").val(),
        type: "get",
      }).done(function (data) {
        Calculator.send(calcData.objects);
      });

      $(".SumOfTotal").val(sum_of_total.toFixed(0));

      return false;
    });

    // New number group
    $("body").on("click", ".numbers .new-value", function (e) {
      e.preventDefault();
      var btn = $(this);
      $.each(calcData.numbers, function (number, visible) {
        if (!visible) {
          calcData.numbers[number] = true;

          // Registers wall
          newWall = new WallSet();
          newWall.name = number;

          // Adds set data el
          var setDataHtml =
            '<div class="add-value" data-val="_' +
            number +
            '" data-type="number">' +
            "<label>" +
            number +
            '</label><input type="text" value="0.00" class="test" readonly />' +
            '<a class="delete-value" href="#"></a>' +
            "</div>";

          btn.parent().before(setDataHtml);

          // Adds wall set gen el
          var wallSetGenHtml =
            '<div class="wall-set" data-wall-number="_' +
            number +
            '">' +
            '<p class="wall-set__choosen">' +
            i18n.wall_set +
            ": <span>" +
            number +
            "</p>" +
            '<p class="wall-set__choosen--small">0.00 m<sup>2</sup></p>' +
            '<div class="walls">' +
            "<p>" +
            i18n.wall +
            ': <span class="wall">0.00</span></p>' +
            "<p>" +
            i18n.gable +
            ': <span class="gable">0.00</span></p>' +
            "<p>" +
            i18n.triangle +
            ': <span class="triangle">0.00</span></p>' +
            "<p>" +
            i18n.detail +
            ': <span class="detail">0.00</span></p>' +
            "<p>" +
            i18n.bow +
            ': <span class="bow">0.00</span></p>' +
            "<p>" +
            i18n.column +
            ': <span class="column">0.00</span></p>' +
            "<p>" +
            i18n.door +
            ': <span class="door">0.00</span></p>' +
            "<p>" +
            i18n.window +
            ': <span class="window">0.00</span></p>' +
            "<p>" +
            i18n.opening +
            ': <span class="opening">0.00</span></p>' +
            "</div>" +
            "</div>";

          $(".wall-set-number-generator").append(wallSetGenHtml);

          // Adds wall set conf el
          var groupHtml = "";
          $.each(calculator.houseGroupElements, function (index, data) {
            groupHtml +=
              '<div class="calc-size ' +
              index +
              '">' +
              '<form class="calc-size__inner flexbox flexbox--grid flexbox--small">' +
              '<div class="col col-50 col-s-full">' +
              '<div class="form-group">' +
              '<a class="delete-value" href="#"></a>' +
              '<div class="form-group__row">' +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[0] +
              "</label>" +
              '<input class="x" type="text" value="0">' +
              "</div>" +
              "</div>" +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[1] +
              "</label>" +
              '<input class="y" type="text" value="0">' +
              "</div>" +
              "</div>" +
              '<div class="form-group__col">' +
              '<div class="add-size">' +
              "<label>" +
              data.labels[2] +
              "</label>" +
              '<input class="n" type="text" value="1">' +
              "</div>" +
              "</div>" +
              "</div>" +
              '<div class="size-summ">' +
              i18n.label_sum +
              ": <span>0.00</span> m<sup>2</sup></div>" +
              "</div>" +
              "</div>" +
              '<div class="col col-50 col-s-full">' +
              '<button class="btn form-group new-size" type="submit">' +
              i18n.label_add +
              "</button>" +
              "</div>" +
              "</form>" +
              "</div>";
          });
          var wallSetConfHtml =
            '<div class="choosen-elements hidden" data-for-configuration="_' +
            number +
            '">' +
            '<div class="image img-bg i_walls"></div>' +
            '<div class="btn-group img-group">' +
            '<a class="btn choose-element active" data-name="i_walls" href="#">' +
            i18n.wall +
            "</a>" +
            '<a class="btn choose-element" data-name="i_gables" href="#">' +
            i18n.gable +
            "</a>" +
            '<a class="btn choose-element" data-name="i_triangles" href="#">' +
            i18n.triangle +
            "</a>" +
            '<a class="btn choose-element" data-name="i_details" href="#">' +
            i18n.detail +
            "</a>" +
            '<a class="btn choose-element" data-name="i_bows" href="#">' +
            i18n.bow +
            "</a>" +
            '<a class="btn choose-element" data-name="i_columns" href="#">' +
            i18n.column +
            "</a>" +
            '<a class="btn choose-element" data-name="i_doors" href="#">' +
            i18n.door +
            "</a>" +
            '<a class="btn choose-element" data-name="i_windows" href="#">' +
            i18n.window +
            "</a>" +
            '<a class="btn choose-element" data-name="i_openings" href="#">' +
            i18n.opening +
            "</a>" +
            "</div>" +
            '<div class="number-' +
            number +
            '">' +
            groupHtml +
            "</div>" +
            "</div>";

          $(".wall-set-number-configuration").append(wallSetConfHtml);

          walls_numbers[number] = newWall;

          return false;
        }
      });
    });

    // deletes number group
    $("body").on("click", ".numbers .add-value .delete-value", function () {
      var val_unformated = $(this).parent(".add-value").data("val");
      var val = $(this).parent(".add-value").data("val").replace("_", "");

      calcData.numbers[val] = false;

      $('[data-wall-number="_' + val + '"]').remove();
      $('[data-for-configuration="_' + val + '"]').remove();

      delete walls_numbers[val];

      $(this).parents(".add-value").remove();

      delete calcData.objects[val_unformated];

      var sum_of_total = $(".SumOfTotal").val();

      sum_of_total -= parseFloat(
        $(this).parents(".add-value").find('input[type="text"]:first').val()
      );

      $.ajax({
        url:
          "/" +
          $(".caluclator-wrap").data("lang") +
          "/generate-pdf/?delete_symbol=" +
          val_unformated +
          "&_wpnonce=" +
          $("#calculator-nonce").val(),
        type: "get",
      }).done(function (data) {
        Calculator.send(calcData.objects);
      });

      $(".SumOfTotal").val(sum_of_total.toFixed(0));

      return false;
    });

    // Changes group selection
    $("body").on(
      "click",
      ".letters .add-value input, .numbers .add-value input",
      function () {
        var val = $(this).parents(".add-value").data("val");
        var type = $(this).parents(".add-value").data("type");
        $(".calculator").attr("data-selected", val);

        /*$('.choosen-wall span').html(val);*/

        $(".wall-set").hide();
        $(".choosen-elements").hide();

        var wall_set;
        var wall_configuration;

        if (type == "letter") {
          wall_set = $('[data-wall-letter="' + val + '"]');
        } else {
          wall_set = $('[data-wall-number="' + val + '"]');
        }

        wall_configuration = $('[data-for-configuration="' + val + '"]');

        if (wall_set.hasClass("hidden")) {
          wall_set.removeClass("hidden");
        }

        if (wall_configuration.hasClass("hidden")) {
          wall_configuration.removeClass("hidden");
        }

        wall_configuration.find(".calc-size").hide();
        wall_configuration.find(".calc-size").first().show();

        wall_set.show();
        wall_configuration.show();

        $(".img-group").show();

        return false;
      }
    );

    // Changes selected house area
    $("body").on("click", ".img-group a", function (e) {
      e.preventDefault();

      // Show corret img;
      $(".img-group a").removeClass("active");
      $(".image.img-bg").removeClassWild("i_*").addClass($(this).data("name"));

      // Make current selection
      $(this).addClass("active");

      // Show input group
      $(".calc-size").hide();
      var top_div = $(this).closest(".choosen-elements");
      var target = "." + $(this).data("name");

      var form_size = $(target);

      form_size.show();
    });

    // Adds new input group to current group
    $("body").on("click", ".calc-size .new-size", function (e) {
      e.preventDefault();
      var label;
      var calc_size = $(this).closest(".calc-size");
      if (calc_size.hasClass("i_gables") || calc_size.hasClass("i_triangles")) {
        label = "&ang;";
      } else {
        label = "y";
      }

      var html =
        '<div class="col col-50">' +
        '<div class="form-group">' +
        '<a class="delete-value" href="#"></a>' +
        '<div class="form-group__row">' +
        '<div class="form-group__col">' +
        '<div class="add-size">' +
        "<label>x</label>" +
        '<input class="x" type="text" value="0">' +
        "</div>" +
        "</div>" +
        '<div class="form-group__col">' +
        '<div class="add-size">' +
        "<label>" +
        label +
        "</label>" +
        '<input class="y" type="text" value="0">' +
        "</div>" +
        "</div>" +
        '<div class="form-group__col">' +
        '<div class="add-size">' +
        "<label>n</label>" +
        '<input class="n" type="text" value="1">' +
        "</div>" +
        "</div>" +
        "</div>" +
        '<div class="size-summ">' +
        i18n.label_sum +
        ": <span>0.00</span> m<sup>2</sup></div>" +
        "</div>" +
        "</div>";

      $(this).parent().before(html);

      focusable = $(this)
        .closest(".calc-size")
        .find("div.form-group")
        .last()
        .find('input[type="text"]')
        .filter(":not([readonly]):enabled");
      next = focusable.eq(focusable.index(this) + 1);

      //console.log(next.length);

      if (next.length) {
        next.focus();
      }
    });

    // Shows large data
    $(".add-value.large input").on("click", function () {
      var val = $(this).parents(".add-value").data("val");
      $(".calculator").attr("data-selected", val);
      /*$('.choosen-wall span').html($(this).parents('.add-value').data('val'));*/

      $(".wall-set").hide();
      $(".choosen-elements").hide();

      var wall_set = $('[data-wall-letter="' + val + '"]');
      var wall_configuration = $('[data-for-configuration="' + val + '"]');

      var firstField = wall_configuration
        .children(".letter-" + val + ":eq(0)")
        .children("form:eq(0)")
        .show();

      if (wall_set.hasClass("hidden")) {
        wall_set.removeClass("hidden");
      }

      if (wall_configuration.hasClass("hidden")) {
        wall_configuration.removeClass("hidden");
      }

      if (val == "purlins" || val == "beams") {
        var name = $(this).parents(".add-value").data("name");
        $(".image.img-bg").removeClassWild("i_*").addClass(name);
      }

      $(".calc-size").show();

      wall_set.show();
      wall_configuration.show();

      $(".img-group").hide();
    });
  },
};
export default calculator;
